var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgSuccessFeatured = function SvgSuccessFeatured(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    fill: "none"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 20,
    fill: "#E2FFEA"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#51C394",
    fillRule: "evenodd",
    d: "M20 29.333A9.333 9.333 0 0 1 10.667 20 9.333 9.333 0 0 1 20 10.667 9.333 9.333 0 0 1 29.333 20 9.333 9.333 0 0 1 20 29.333M8 20c0-6.627 5.373-12 12-12s12 5.373 12 12-5.373 12-12 12S8 26.627 8 20m17.787-1.71a1.333 1.333 0 1 0-1.86-1.913l-5.914 5.75-2.404-2.403a1.333 1.333 0 1 0-1.885 1.886l3.333 3.333c.516.515 1.35.521 1.872.013z",
    clipRule: "evenodd"
  })));
};
export default SvgSuccessFeatured;